import ViolationsTabDetailsActions from './ViolationsTabDetailsActions';

export default ViolationsTabDetailsActions;
